// 每个页面、产品共用一次读取；查询结束后计时，避免慢接口重叠。
export function createChargingStatisticsFeed ({ request, interval = 10000, document: doc = typeof document === 'undefined' ? null : document, schedule = setTimeout, cancel = clearTimeout }) {
  const listeners = new Set()
  let stopped = false, running = false, timer, active, last
  const publish = value => { last = value; listeners.forEach(listener => listener(value)) }
  const refresh = async () => {
    if (stopped || running || doc && doc.hidden) return
    cancel(timer); running = true
    try {
      active = request()
      const snapshot = await active.promise
      if (!stopped) publish({ status: 'ready', snapshot })
    } catch (error) { if (!stopped) publish({ status: 'error', error }) }
    finally {
      active = null; running = false
      if (!stopped && !(doc && doc.hidden)) timer = schedule(refresh, Math.max(10000, interval))
    }
  }
  const visibility = () => { cancel(timer); if (!(doc && doc.hidden)) refresh() }
  if (doc) doc.addEventListener('visibilitychange', visibility)
  return {
    subscribe (listener) { if (stopped) throw new Error('统计读取已结束'); listeners.add(listener); if (last) listener(last); else refresh(); return () => listeners.delete(listener) },
    refresh,
    get size () { return listeners.size },
    dispose () { stopped = true; cancel(timer); if (active && active.cancel) active.cancel(); listeners.clear(); if (doc) doc.removeEventListener('visibilitychange', visibility) }
  }
}
